import styled from 'styled-components';
import { styledTable } from '../styled/mixin';
import Table, { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import { ExpenseHistory } from '../../modules/expenses';
import { Button, Col, Row } from 'antd';
import Title from 'antd/lib/typography/Title';

const StyledDiv = styled.div`
  ${styledTable}
`;

interface ExpenseHistoriesComponentProps {
  expenseHistories: ExpenseHistory[];
  onOpenCreateExpenseCommentModal: () => void;
}

function ExpenseHistoriesComponent({
  expenseHistories,
  onOpenCreateExpenseCommentModal,
}: ExpenseHistoriesComponentProps) {
  const columns: ColumnsType<ExpenseHistory> = [
    {
      title: '사용자',
      dataIndex: ['user', 'name'],
      width: '20%',
    },
    {
      title: '설명',
      dataIndex: 'description',
      width: '60%',
    },
    {
      title: '변경일시',
      dataIndex: 'createdAt',
      width: '20%',
      render: (text: any, record: any, index: any) =>
        moment(record.createdAt).format('YYYY-MM-DD HH:mm:ss'),
    },
  ];

  return (
    <StyledDiv>
      <Row justify={'space-between'}>
        <Col>
          <Title level={5}>히스토리</Title>
        </Col>
        <Col>
          <Button onClick={onOpenCreateExpenseCommentModal} size="small">
            추가
          </Button>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Table<any>
            rowKey="id"
            columns={columns}
            dataSource={expenseHistories}
            pagination={false}
          />
        </Col>
      </Row>
    </StyledDiv>
  );
}
export default ExpenseHistoriesComponent;
